'use client'

import React from 'react'
import { InputGroup as ChakraInputGroup } from '@chakra-ui/react'

export function InputLeftElement({ children, ...props }) {
  // Marcador v2: InputGroup lo consume y no se renderiza tal cual.
  return null
}
InputLeftElement.displayName = 'InputLeftElement'
InputLeftElement.__inputGroupSlot = 'start'

export function InputRightElement({ children, ...props }) {
  return null
}
InputRightElement.displayName = 'InputRightElement'
InputRightElement.__inputGroupSlot = 'end'

function getSlot(child) {
  if (!React.isValidElement(child)) return null
  const t = child.type
  if (t === InputLeftElement || t?.__inputGroupSlot === 'start' || t?.displayName === 'InputLeftElement') {
    return 'start'
  }
  if (t === InputRightElement || t?.__inputGroupSlot === 'end' || t?.displayName === 'InputRightElement') {
    return 'end'
  }
  return null
}

/**
 * Compat Chakra v2: hijos InputLeftElement / InputRightElement + Input.
 * Chakra v3 exige exactamente un ReactElement hijo (Children.only).
 */
export const InputGroup = React.forwardRef(function InputGroup(
  { children, startElement, endElement, startElementProps, endElementProps, ...props },
  ref,
) {
  let start = startElement
  let end = endElement
  let startProps = startElementProps
  let endProps = endElementProps
  const inputChildren = []

  React.Children.forEach(children, (child) => {
    if (child == null || child === false || child === true) return
    const slot = getSlot(child)
    if (slot === 'start') {
      const { children: slotChildren, ...restProps } = child.props || {}
      start = slotChildren
      startProps = { ...startProps, ...restProps }
      return
    }
    if (slot === 'end') {
      const { children: slotChildren, ...restProps } = child.props || {}
      end = slotChildren
      endProps = { ...endProps, ...restProps }
      return
    }
    if (React.isValidElement(child)) {
      inputChildren.push(child)
    }
  })

  const input = inputChildren[0]
  if (!input) {
    return null
  }

  return (
    <ChakraInputGroup
      ref={ref}
      startElement={start}
      endElement={end}
      startElementProps={startProps}
      endElementProps={endProps}
      {...props}
    >
      {input}
    </ChakraInputGroup>
  )
})
